import React from 'react';

import './LocationSection.css';

export const LocationSection = () => {
  return (
    <div className="location-container">
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          flex: 0.7,
          //   justifyContent: 'center',
          alignItems: 'center',
          padding: '0% 2%',
        }}
      >
        <h3 style={{ fontSize: '32px', textAlign: 'center' }}>
          RideNow Orlando Auction
        </h3>

        <p style={{ textAlign: 'center', margin: '0 4%', padding: '0 8%' }}>
          <span>Want to come to the auction in person? </span>
          <br />
          <br />
          Hop on over to our Orlando, Florida, location and come see the
          inventory in person, and even take a test ride! Not in the area? You
          can still bid online from anywhere, and we would love to have you at
          any one of our traditional retail dealerships across the country.
        </p>

        <br />

        <button
          style={{
            backgroundColor: '#EE3124',
            color: '#FFFFFF',
            padding: '1%',
            width: '200px',
          }}
          onClick={() =>
            window.open(
              'https://www.google.com/maps/place/RideNow+Orlando/@28.5821013,-81.5584932,15z/data=!4m2!3m1!1s0x0:0x6de40a1e47da5c0d?sa=X&ved=2ahUKEwj-wsTtsdT7AhUvmmoFHe8FCG4Q_BJ6BAhxEAg',
              '_blank'
            )
          }
        >
          Get Directions
        </button>
      </div>

      <div
        style={{
          display: 'flex',
          flex: 0.4,
          justifyContent: 'center',
          //   alignItems: 'center',
          padding: '0% 2%',
        }}
      >
        <iframe
          width="400px"
          height="400px"
          style={{ border: 0 }}
          loading="lazy"
          // allowfullscreen
          src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJFy1XFXGD54gRDVzaRx4K5G0&key=AIzaSyCJH8w6pFbOUfA1qwB1CeztrQ_W1THyFZw"
        ></iframe>
      </div>
    </div>
  );
};
